//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faChevronRight, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
// reference: https://github.com/bootstrap-vue/bootstrap-vue/blob/dev/src/components/pagination/pagination.js
export default {
  name: 'base-pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    perPage: {
      type: Number,
      default: 20,
    },
    totalRows: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      faChevronRight,
      faChevronLeft,
    };
  },
  computed: {
    page() {
      return this.currentPage;
    },
    pageTotal() {
      return Math.ceil(this.totalRows / this.perPage, 10);
    },
  },
  methods: {
    changePage(page) {
      page = Math.min(this.pageTotal, Math.max(1, page));
      this.$emit('change', page);
    },
  },
};
